import React from 'react';
import { PrismicSliceFaqSection } from 'src/types';
import { Accordion, AccordionHeader, AccordionContent } from 'src/ui/accordion';
import * as S from './styles';
import RichText, { plainText } from '../rich-text';

type Props = Pick<PrismicSliceFaqSection, 'faqTitle' | 'items'>;

const FAQ = ({ faqTitle, items }: Props) => {
  return (
    <S.FaqContainer>
      {faqTitle && <RichText data={faqTitle} />}
      {Array.isArray(items)
        ? items.map(item => {
            const questionAsPlainText = plainText(item.question);
            return (
              <Accordion key={questionAsPlainText} id={questionAsPlainText}>
                <AccordionHeader>
                  <S.span data={item.question} />
                </AccordionHeader>
                <AccordionContent>
                  <S.span data={item.answer} />
                </AccordionContent>
              </Accordion>
            );
          })
        : null}
    </S.FaqContainer>
  );
};

export default FAQ;
